var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackMuteinline = function SvgBlackMuteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 41.45v-3.1q4.85-1.4 7.925-5.375T39 23.95t-3.05-9.05T28 9.55v-3.1q6.2 1.4 10.1 6.275T42 23.95t-3.9 11.225T28 41.45M6 30V18h8L24 8v32L14 30Zm21 2.4V15.55q2.75.85 4.375 3.2T33 24q0 2.85-1.65 5.2T27 32.4m-6-16.8L15.35 21H9v6h6.35L21 32.45ZM16.3 24"
  })));
};
export default SvgBlackMuteinline;